module.exports = __webpack_public_path__ + "static/media/cover.ebd75867.svg";